import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import DataTableCellField from "@/components/data-table/components/DataTableCellField";
import { DirtyAwareCell } from "@/contexts/FormTableCellDirtyContext";
import { CostItem } from "@/types/costs";

export const useCostsColumnOverrides = (): Record<
  string,
  ColumnDef<CostItem, unknown>
> => {
  return useMemo(
    () => ({
      name: {
        id: "name",
        cell: ({ row }) => {
          const fieldPath = `costs.${row.original.id}.name`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} />
            </DirtyAwareCell>
          );
        },
      },
      amount: {
        id: "amount",
        cell: ({ row }) => {
          const fieldPath = `costs.${row.original.id}.amount`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="number" />
            </DirtyAwareCell>
          );
        },
      },
      comment: {
        id: "comment",
        cell: ({ row }) => {
          const fieldPath = `costs.${row.original.id}.comment`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} />
            </DirtyAwareCell>
          );
        },
      },
      include: {
        id: "include",
        cell: ({ row }) => {
          const fieldPath = `costs.${row.original.id}.include`;
          return (
            <DirtyAwareCell fieldPath={fieldPath}>
              <DataTableCellField name={fieldPath} type="checkbox" />
            </DirtyAwareCell>
          );
        },
      },
    }),
    [],
  );
};
